import React, { useState, useEffect } from 'react';
import axios from 'axios';
import api from '../../api';
import { useAuth } from '../../context/AuthContext';
import { useSocket } from '../../context/SocketContext';
import useBlockCheck from '../../hooks/useBlockCheck';
import { useNavigate } from 'react-router-dom';
import './UserNotifications.css';
import { Trash2 } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaBell } from 'react-icons/fa';
import { useNotifications } from '../../context/NotificationContext';
import UsersTopbar from '../UsersTopbar/UsersTopbar';

const UserNotifications = () => {
  const { token, profile } = useAuth();
  const { socket } = useSocket();
  const navigate = useNavigate();
  const { notificationCount, notifications, markAsRead } = useNotifications();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useBlockCheck('user');

  // Fetch notifications ONCE when the component mounts
  useEffect(() => {
    const fetchNotifications = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(api.getUserNotifications, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const sorted = (res.data.notifications || []).sort((a, b) =>
          new Date(b.date) - new Date(a.date),
        );
      } catch (err) {
        setError('Failed to load notifications.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchNotifications();
  }, [token]);

  // Listen for real-time notifications using Socket.IO
  useEffect(() => {
    if (socket && profile?._id) {
      const handleNewGiftNotification = (data) => {
        if (data.userId === profile._id) {
          toast.success('New gift notification received!');
        }
      };
      socket.on('newGiftNotification', handleNewGiftNotification);
      
      return () => socket.off('newGiftNotification', handleNewGiftNotification);
    }
  }, [socket, profile?._id]);

  useEffect(() => {
    if (socket) {
      // console.log('Socket connected:', socket.connected, 'Socket ID:', socket.id);
      socket.on('connect', () => {
        // console.log('Socket connected (event):', socket.id);
      });
      socket.on('disconnect', () => {
        // console.log('Socket disconnected (event):', socket.id);
      });
      socket.on('newGiftNotification', (data) => {
        // console.log('Received newGiftNotification:', data);
      });
    }
  }, [socket]);

  // const markAsRead = async (notificationId) => {
  //   await axios.patch(
  //     `${api.getUserNotifications}/${notificationId}/read`,
  //     {},
  //     { headers: { Authorization: `Bearer ${token}` } }
  //   );
  //   setNotifications((prev) =>
  //     prev.map((notif) =>
  //       notif._id === notificationId ? { ...notif, read: true } : notif
  //     )
  //   );
  // };

  const handleClose = () => {
    navigate('/home');
  };

  const handleNotificationClick = (notif) => {
    if (notif.courseId) {
      markAsRead(notif._id);
      if (notif.message.toLowerCase().includes('gift')) {
        navigate('/gifted', { state: { tab: 'received' } });
      } else if (notif.message.includes('has been updated')) {
        navigate(`/course/${notif.courseId}`);
      }
    }
  };

  // const handleNotificationsClick = () => {
  //   navigate("/notifications");
  // };

  if (loading) return <div>Loading notifications...</div>;
  if (error) return <div className="error-message">{error}</div>;

  const unreadNotifications = notifications.filter((notif) => !notif.read);

  return (
    <div>
      <UsersTopbar />
   
      <div className="notifications-page">
        <button className="notifications-close-btn" onClick={handleClose} aria-label="Close">
        ✖
        </button>

        <div className="notifications-header">
          <h1>Notifications</h1>
        </div>

        {unreadNotifications.length === 0 && (
          <div className="no-notifications">
            <p>No new notifications</p>
          </div>
        )}

        <div className="notifications-list">
          {unreadNotifications.map((notif) => (
            <div
              key={notif._id}
              className={`notification-item ${notif.read ? 'read' : 'unread'}`}
              onClick={() => handleNotificationClick(notif)}
            >
              <div className="notification-content">
                <p className="notification-message">{notif.message}</p>
                <small className="notification-date">
                  {new Date(notif.date).toLocaleString()}
                </small>
              </div>
              <div className="notification-actions">
                {!notif.read && (
                  <button
                    className="mark-read-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      markAsRead(notif._id);
                    }}
                    aria-label="Mark as read"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default UserNotifications;
